import * as actions from './index';

export function clearPlacedOrderData(requestBody, mode) {
  return dispatch => {
    dispatch(actions.clearPlacedOrderData());
  };
}
